import { post, postFile, postExFile, getExFile } from "@utils/httpUtil";

export interface IactiveInfo {
  type: number; // 活动类型
  name: string; // 活动名称
  introduce: string; // 活动简介
  cover: string; // 活动封面
  beginTime: string; // 活动开始时间
  finishTime: string; // 活动结束时间
  inviteUserType: 0 | 1 | 2 | 3; //用户类型  0：无 1：授信用户 2：认证用户 3：其他
  interactType: "COMMENT" | "LIVE"; // 互动类型 0：发布评论 1：直播
  contentRangeType: 0 | 1; // 内容范围设置 0：内容类型 1：指定内容
  contentType: 0 | 1; // 内容类型 0：文章 1：直播
  priceType: 1 | 2 | 3; // 报价类型 1等额；2职称报价 3:指定报价
  eachRewardAmount: number; // 每次参与奖励
  eachLimit: number; // 每人可参与次数
  totalLimit: number; // 要求次数
  actualExpendAmount: number; // 计划支出金币
}

export interface IdoctorInfo {
  name?: string;
  doctorName?: string;
  profession?: string;
  doctorType?: string;
  phone?: string;
  practiceTypeName?: string;
  doctorId?: string;
  userId?: string;
  title?: string;
  departmentName?: string;
  deptName?: string;
  labels?: any;
  labelInfoList?: any;
  provinceId?: string;
  provinceCode?: string;
  cityId?: string;
  cityCode?: string;
  areaId?: string;
  areaCode?: string;
  joinStatus?: string;
  realNameAudit?: string;
  qualificationAudit?: string;
  departmentId?: string;
  secondDeptId?: string;
  insertStatus?: boolean;
  auth?: boolean;
  isCredit?: boolean;
  credit?: boolean;
  joined?: boolean;
  communityDoctorId?: number;
  id?: number;
  onlineStatus?: string;
}

export interface departItem {
  id: number;
  name: string;
}

export enum IliveModeType {
  SPEAKER = "SPEAKER",
  GUEST = "GUEST",
}

export enum ItransmissionSource {
  WECHAT_MOMENTS = "WECHAT_MOMENTS", // 微信朋友圈
  WECHAT_FRIEND = "WECHAT_FRIEND", // 微信好友
}

export enum ItransmissionSourceName {
  WECHAT_MOMENTS = "朋友圈", // 微信朋友圈
  WECHAT_FRIEND = "微信好友", // 微信好友
}

export enum IContentRangeType {
  CONTENT_TYPE = "CONTENT_TYPE",
  ASSIGN_CONTNET = "ASSIGN_CONTNET",
}

export enum IContentRangeTypeStatus {
  CONTENT_TYPE = "CONTENT_TYPE",
  ASSIGN_CONTNET = "ASSIGN_CONTNET",
}

export enum IInteractType {
  COMMENT = "COMMENT", // 发布评论
  LIVE = "LIVE", // 直播讲课
  QUESTIONNAIRE = "QUESTIONNAIRE", // 调查问卷
  ANSWERQUESTIONS = "ANSWER_QUESTIONS", // 答题
  STUDY = "STUDY", // 学习内容
}

export enum IInteractTypeStatus {
  COMMENT = "COMMENT", // 发布评论
  LIVE = "LIVE", // 直播讲课
  QUESTIONNAIRE = "QUESTIONNAIRE", // 调查问卷
  ANSWER_QUESTIONS = "ANSWER_QUESTIONS", // 答题
  STUDY = "STUDY", // 学习内容
}

export enum IUserSource {
  CONDITIONAL = "CONDITIONAL", // 条件筛选
  LIST_IMPORT = "LIST_IMPORT", // 名单导入
}

export enum IInteractTypeName {
  COMMENT = "发布评论",
  LIVE = "直播讲课",
  LIVE_TRANSMISSION = "直播讲课",
  QUESTIONNAIRE = "参与问卷",
  ANSWER_QUESTIONS = "参与答题",
  STUDY = "学习内容",
}

export enum transmissionNodeName {
  AUTO = "自动发奖",
  MANUAL = "手动发奖",
  STUDY = "学习内容",
}

export enum IContentType {
  ARTICLE = "ARTICLE",
  LIVE = "LIVE",
}

export enum IContentTypeName {
  ARTICLE = "文章",
  LIVE = "直播",
  ANSWER_QUESTIONS = "答题",
  COURSE = "课程",
  QUESTIONNAIRE = "问卷",
}

export enum IActivityInteractType {
  INTERACT = "INTERACT",
  AUTHORIZATION = "AUTHORIZATION",
  CONTRIBUTE = "CONTRIBUTE",
}

export enum IPriceType {
  SAME_PRICE = "SAME_PRICE", // 等额
  TITLE_PRICE = "TITLE_PRICE", // 职称报价
  ASSIGN_PRICE = "ASSIGN_PRICE", // 指定报价
}

export enum IPriceTypeStatus {
  SAME_PRICE = "等额报价",
  TITLE_PRICE = "职称报价",
  ASSIGN_PRICE = "分开报价",
}
export enum IAuditNodeStatus {
  AUDIT = "审核发奖",
  AUTO = "自动发奖",
}

export interface IFormatInteractionsNum {
  [key: number]: string;
}

export const IInteractionsNum = {
  3: "1v1",
  4: "1v3",
  7: "1v6",
  10: "1v9",
  13: "1v12",
  16: "1v15",
};

export const IActiveType = {
  //  ARTICLE(0, "文章邀约"),
  //   SUBJECT(1, "专题邀约"),
  //   QUESTIONS_ANSWER(2, "问答邀约"),
  //   MEDICAL(3, "病例活动"),
  //   LEARNING(4, "学术任务"),
  //   INTERACT(5, "学术互动"),
  //   AUTHORIZATION(6, "学术授权");
  ARTICLE: "文章邀约",
  SUBJECT: "专题邀约",
  QUESTIONS_ANSWER: "问答邀约",
  MEDICAL: "病例邀约",
  LEARNING: "学术任务",
  INTERACT: "互动类",
  AUTHORIZATION: "授权类",
  CONTRIBUTE: "投稿类",
};

export function pageInteractActivity(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/center/page`, data, config);
}

// 互动活动详情
export function activityinteractDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/interact/detail`, data, config);
}

// 互动活动详情
export function activityauthorizeDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/authorize/detail`, data, config);
}

// 互动活动详情
export function activityContributeDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/contribute/detail`, data, config);
}

// 结束活动
export function activityinteractEnd(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/interact/end`, data, config);
}
// 结束活动
export function activityauthorizeEnd(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/authorize/end`, data, config);
}
// 结束活动
export function activityContributeEnd(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/contribute/end`, data, config);
}

// 根据手机号查询邀请医生信息
export function activityinteractGetUserByPhone(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/center/getUserByPhone`, data, config);
}

// 导入指定报价
export function activityinteractImportAssignPrice(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postFile(`activity/interact/importAssignPrice`, data, config);
}

// 导入医生
export function activityinteractImportDoctor(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postFile(`activity/center/importDoctor`, data, config);
}

// 导入医生V2
export function activityinteractImportDoctorV2(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postFile(`activity/center/importDoctorV2`, data, config);
}

// 匹配符合条件的医生
export function activityinteractMatchUser(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/center/matchUser`, data, config);
}

// // 分页查询互动活动列表
// export function activityinteractPageInteractActivity(data: Record<string | number, any>, config?: Record<string | number, any>) {
//   return post(`activity/interact/pageInteractActivity`, data, config);
// }

// 保存/修改互动活动
export function activityinteractSave(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/interact/save`, data, config);
}
// 保存/修改互动活动
export function activityauthorizeSave(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/authorize/save`, data, config);
}
// 保存/修改互动活动
export function activitycontributeSave(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/contribute/save`, data, config);
}

// 活动列表导出
export function exportActivityInteract(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`medicine/excel/exportActivityInteract`, data, config);
}
// 课程搜索
export function authorizeFindEsCourseAggregationPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/authorize/findEsCourseAggregationPage`, data, config);
}

// 互动内容明细列表
export function academicRecordPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`academic/record/page`, data, config);
}
// b端后台授权活动明细列表
export function activityAuthorizePage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/authorize/page`, data, config);
}

// 活动名称下拉列表
export function recordAcademicActivitySelect(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`academic/record/academicActivitySelect`, data, config);
}
// 活动名称下拉列表
export function queryActivityName(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/center/queryActivityName`, data, config);
}
// 活动名称下拉列表
export function activityAuthorizeExport(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`activity/authorize/export`, data, config);
}

// 导出学术互动活动明细列表 已通过
export function academicRecordExport(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`academic/record/export`, data, config);
}
// 导出学术互动活动明细列表 拒绝
export function academicExportReject(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`academic/record/exportReject`, data, config);
}
// 导出学术互动活动明细列表 待审核
export function academicExportWaitSelect(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`academic/record/exportWaitSelect`, data, config);
}

// 批量通过/拒绝内容
export function academicRecordBatchOperate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`academic/record/batchOperate`, data, config || { ignoreError: true });
}

// 删除内容
export function academicRecordDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`academic/record/delete`, data, config);
}

// 删除内容
export function exportFailDoctorData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`medicine/excel/exportFailDoctorData`, data, config);
}
export function activityExportFailExcelApi(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return getExFile(`activity/interact/exportFailExcel`, data, config);
}
//医生直播列表
export function interactFindLive(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/interact/findLive`, data, config);
}

//投稿类活动明细-待筛选
export function pageWaitSelect(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/contribute/pageWaitSelect`, data, config);
}

//投稿类活动明细-已采纳
export function pageAdopt(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/contribute/pageAdopt`, data, config);
}

//投稿类活动明细-已采纳
export function pageReject(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/contribute/pageReject`, data, config);
}

//投稿类活动明细-采纳投稿
export function contributeAdopt(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/contribute/adopt`, data, config || { ignoreError: true });
}

//投稿类活动明细-采纳投稿
export function contributeReject(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/contribute/reject`, data, config);
}

//投稿类活动明细-撤回拒绝投稿
export function contributeWithdraw(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/contribute/withdraw`, data, config);
}

//投稿类活动明细-删除投稿
export function contributeDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/contribute/delete`, data, config);
}

//投稿类活动明细-导出-已采纳-待奖励
export function exportAdopt(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`activity/contribute/exportAdopt`, data, config);
}

//投稿类活动明细-导出-已采纳-已奖励
export function exportAdoptZip(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`activity/contribute/exportAdoptZip`, data, config);
}
//投稿类活动明细-导出-已采纳-已奖励
export function exportSelectZip(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`activity/contribute/exportSelectZip`, data, config);
}
//投稿类活动明细-导出-已采纳-已奖励
export function exportRejectZip(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`activity/contribute/exportRejectZip`, data, config);
}

//投稿类活动明细-导出-已采纳-已奖励
export function exportAdoptReward(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`activity/contribute/exportAdoptReward`, data, config);
}

//投稿类活动明细-导出-拒绝
export function exportReject(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`activity/contribute/exportReject`, data, config);
}

//投稿类活动明细-导出-待筛选
export function exportSelect(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`activity/contribute/exportSelect`, data, config);
}

//学习内容详情 导出数据
export function exportInviteUser(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`activity/interact/exportInviteUser`, data, config);
}

//投稿类活动明细-发放稿费
export function grantPaymentReward(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/contribute/grantPaymentReward`, data, config || { ignoreError: true });
}

//投稿类活动明细-发放传播费
export function grantTransmissionReward(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/contribute/grantTransmissionReward`, data, config || { ignoreError: true });
}

//互动类活动明细-发放传播费
export function authorizeGrantTransmissionReward(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/authorize/grantTransmissionReward`, data, config);
}

//医生直播列表
export function getQuestionnaireDetailList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`academic/getQuestionnaireDetail`, data, config);
}
//批量发奖
export function recordBatchReward(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`academic/record/batchReward`, data, config || { ignoreError: true });
}
//暂存活动
export function saveOrUpdateActivityStash(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/saveOrUpdateActivityStash`, data, config);
}
//查询暂存活动
export function getActivityStash(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/getActivityStash`, data, config);
}
//保存/修改 自动采集文章配置信息
export function collectConfigSave(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/collect/config/save`, data, config);
}
//保存/修改 自动采集文章配置信息
export function collectConfigGetCollectConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`activity/collect/config/getCollectConfig`, data, config);
}
